import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import { EmptyState } from "../../../../components/common/EmptyState";
import { emptyStateIcons } from "../../../stack/environment/icons/iconExport";

const NoResultsMessage = ({ resetFilters }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        width: "100%",
        height: "100%",
      }}
    >
      <EmptyState
        icon={emptyStateIcons.NoResultsIcon}
        title="No matching results"
        description={`It looks like no data matches the filters you've set.\n Adjust or clear them to broaden your view.`}
      />

      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={1}
        height={"36px"}
        alignItems={"center"}
        justifyContent={"center"}
        border={"1px solid " + colors.grey_20percent}
        borderRadius={"12px"}
        width={"auto"}
        padding={"0px 12px"}
        sx={{ cursor: "pointer" }}
        onClick={() => {
          resetFilters();
        }}
      >
        <Typography variant="subtitle2" color={colors.text_secondary}>
          Clear filters
        </Typography>
      </Box>
    </Box>
  );
};

export default NoResultsMessage;
